export const DATE_PICKER_DATE_FORMAT = 'yyyy-MM-dd';

export const SERVER_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';

export const WEBINAR_SLOTS_DATE_DISPLAY_FORMAT = 'eeee (dd-MM-yyyy)';

export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const USER_READABLE_DATE_FORMAT = 'dd MMM yyyy';

export const DDMMYYYY_DATE_FORMAT = 'dd-MM-yyyy';

export const WEEK_DAYS_COUNT = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

export const HOURS_MINUTES_TIME_FORMAT = 'p';

export const AM = 'AM';
export const PM = 'PM';

export const IST_TIMEZONE_OFFSET = 5.5 * 60;
